import { action_options, app_modules } from "helpers/apps_modules_list";
import DispatchViewDetails from "pages/Inventory/Dispatch/Dispatch/ViewDetails/DispatchViewDetails";
import Dispatch from "pages/Inventory/Dispatch/DispatchContainer";
import ViewDispatchIssueLabour from "pages/Inventory/Dispatch/IssueToLabour/ViewDetails/IssueToLabourViewDetails";
import ViewDispatchStocktransfer from "pages/Inventory/Dispatch/StockTransfer/ViewDetails/StockTransferViewDetails";
import InventoryInStock from "pages/Inventory/Inventory/index";
import StockOverViewDetails from "pages/Inventory/Inventory/ViewDetails/StockOverViewDetails";
import WarehousewiseStockDetailsPage from "pages/Inventory/Inventory/ViewDetails/WareHouseWiseStockDetails";
import InventoryOrder from "pages/Inventory/Order/List/Order";
import ViewInventoryOrder from "pages/Inventory/Order/ViewDetails/ViewOrderDetails";
import ReorderLevelContainer from "../../pages/Inventory/ReorderLevel/ReorderLevelContainer";

const InventoryRoutes: any = [
  {
    path: "/inventory-in-stock",
    name: "Inventory In Stock",
    component: <InventoryInStock />,
    permissions: {
      app_name: app_modules?.inventory?.app_name,
      module_name: app_modules?.inventory?.modules?.in_stock,
      action: action_options?.view,
    },
  },

  {
    path: "/view-stockoverview-in-stock/:id",
    name: "Inventory In Stock",
    component: <StockOverViewDetails />,
    permissions: {
      app_name: app_modules?.inventory?.app_name,
      module_name: app_modules?.inventory?.modules?.in_stock,
      action: action_options?.view,
    },
  },

  {
    path: "/view-warehousewisestockdetails/:item_id/:warehouse_id",
    name: "Inventory In Stock",
    component: <WarehousewiseStockDetailsPage />,
    permissions: {
      app_name: app_modules?.inventory?.app_name,
      module_name: app_modules?.inventory?.modules?.in_stock,
      action: action_options?.view,
    },
  },

  //dispatch routes
  {
    path: "/inventory-dispatch",
    name: "Inventory Dispatch",
    component: <Dispatch />,
    permissions: {
      app_name: app_modules?.inventory?.app_name,
      module_name: app_modules?.inventory?.modules?.dispatch,
      action: action_options?.view,
    },
  },
  // {
  //   path: "/inventory-dispatch-view",
  //   name: "Inventory Dispatch view",
  //   component: <DispatchViewDetails />,
  //   permissions: {
  //     app_name: app_modules?.inventory?.app_name,
  //     module_name: app_modules?.inventory?.modules?.dispatch,
  //     action: action_options?.view,
  //   },
  // },
  {
    path: "/inventory-order",
    name: "Inventory Order",
    component: <InventoryOrder />,
    permissions: {
      app_name: app_modules?.inventory?.app_name,
      module_name: app_modules?.inventory?.modules?.order,
      action: action_options?.view,
    },
  },
  {
    path: "/view-inventoryorder/:id",
    component: <ViewInventoryOrder />,
    permissions: {
      app_name: app_modules?.inventory?.app_name,
      module_name: app_modules?.inventory?.modules?.order,
      action: action_options?.view,
    },
  },
  {
    path: "/inventory-dispatch/StockTransfer/view-details/:id",
    component: <ViewDispatchStocktransfer />,
    permissions: {
      app_name: app_modules?.inventory?.app_name,
      module_name: app_modules?.inventory?.modules?.dispatch,
      action: action_options?.view,
    },
  },
  {
    path: "/inventory-dispatch/dispatch/view-details/:dispatch_id",
    name: "Inventory Dispatch Dispatch view Deatils",
    component: <DispatchViewDetails />,
    permissions: {
      app_name: app_modules.inventory.app_name,
      module_name: app_modules.inventory.modules.dispatch,
      action: action_options?.view,
    },
  },
  {
    path: "/inventory-reorder-level",
    name: "Inventory Reorder level",
    component: <ReorderLevelContainer />,
    permissions: {
      app_name: app_modules.inventory.app_name,
      module_name: app_modules.inventory.modules.reorder_level,
      action: action_options?.view,
    },
  },
  {
    path: "/inventory-dispatch/issuelabour/view-details/:id",
    component: <ViewDispatchIssueLabour />,
    permissions: {
      app_name: app_modules?.inventory?.app_name,
      module_name: app_modules?.inventory?.modules?.dispatch,
      action: action_options?.view,
    },
  },
  
];

export default InventoryRoutes;
